import {
    CustomOptionOfferResponseDTO,
    OfferKind,
    OfferLinkedLocationType,
    OfferResponseDTO,
    PartLiteTypes,
    StandardPartOfferResponseDTO,
} from '@luminovo/api-contracts';

export function isStandardPartOffer(offer: OfferResponseDTO): offer is StandardPartOfferResponseDTO {
    return offer.kind === OfferKind.StandardPart;
}

export function isCustomOptionOffer(offer: OfferResponseDTO): offer is CustomOptionOfferResponseDTO {
    return offer.kind === OfferKind.CustomPart;
}

export function isStandardPartMarketOffer(offer: StandardPartOfferResponseDTO): boolean {
    return offer.linked_location.type === OfferLinkedLocationType.SupplierAndStockLocation;
}

export function isStandardPartInventoryOffer(offer: StandardPartOfferResponseDTO): boolean {
    return offer.linked_location.type === OfferLinkedLocationType.InventorySite;
}

export function isOffTheShelfPartOffer(offer: StandardPartOfferResponseDTO): boolean {
    return offer.linked_part.kind === PartLiteTypes.OffTheShelf;
}

export function isInternalPartNumberOffer(offer: StandardPartOfferResponseDTO): boolean {
    return offer.linked_part.kind === PartLiteTypes.Ipn;
}

export function isCustomPartOffer(offer: CustomOptionOfferResponseDTO): boolean {
    return offer.linked_part.kind === PartLiteTypes.Custom;
}

export function isCustomComponentOffer(offer: CustomOptionOfferResponseDTO): boolean {
    return offer.linked_part.kind === PartLiteTypes.CustomComponent;
}

export function isCustomOptionMarketOffer(offer: CustomOptionOfferResponseDTO): boolean {
    return offer.linked_location.type === OfferLinkedLocationType.SupplierAndStockLocation;
}

export function isCustomOptionInventoryOffer(offer: CustomOptionOfferResponseDTO): boolean {
    return offer.linked_location.type === OfferLinkedLocationType.InventorySite;
}
